import { z } from 'zod';
import dayjs from 'dayjs';
import { TFunction } from 'i18next';

export const dndSchema = (t: TFunction) =>
  z.object({
    status: z.string().min(1, t('message_is_required')).max(100, t('status_must_be_at_most_100_characters')),
    time: z
      .string()
      .min(1, t('time_is_required'))
      .refine((val) => dayjs(val, 'HH:mm:ss', true).isValid(), {
        message: t('invalid_time_format'),
      }),

    date: z
      .string()
      .min(1, t('date_is_required'))
      .refine((val) => dayjs(val, 'YYYY-MM-DD', true).isValid(), {
        message: t('invalid_date_format'),
      }),
  });
